export const CLASS_INPUTS = 'w-full md:min-w-[200px] md:max-w-[200px] md:min-w-[250px] md:max-w-[250px]';